var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "copyright", title: "Copyright & Content Ownership" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Font Awesome does not pre-screen Content, but Font Awesome and its designee have the right (but not the obligation) in their sole discretion to refuse\n        or remove any Content that is available via the Service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You shall defend Font Awesome against any claim, demand, suit or proceeding made or brought against Font Awesome by a third-party alleging that Your\n        Content, or Your use of the Service in violation of this Agreement, infringes or misappropriates the intellectual property rights of a third-party or\n        violates applicable law, and shall indemnify Font Awesome for any damages finally awarded against, and for reasonable attorney's fees incurred by,\n        Font Awesome in connection with any such claim, demand, suit or proceeding; provided, that Font Awesome (a) promptly gives You written notice of the\n        claim, demand, suit or proceeding; (b) gives You sole control of the defense and settlement of the claim, demand, suit or proceeding (provided that\n        You may not settle any claim, demand, suit or proceeding unless the settlement unconditionally releases Font Awesome of all liability); and (c)\n        provides to You all reasonable assistance, at Your expense.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        The look and feel of the Service is copyright © Fonticons, Inc. All rights reserved. You may not duplicate, copy, or reuse any portion of the\n        HTML/CSS, Javascript, or visual design elements or concepts without express written permission from Font Awesome.\n      "
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }